import { FooterService } from '../service/footer.service'
import { GenericContentDto } from '../model/genericContentDto';
import { GenericMemberResponsePortalResponseDto } from '@app/core/models/genericMembeResponsePortalResponseDto';
import { Helper } from '@rawlings/core';
import { PHONE_NUMBER, PRIVACY_POLICY } from '../model/constants';

export function initializerPrivayPolicy(privacyPolicyService: FooterService) : ()=> Promise<void>
{
    return ()=>
        new Promise<void>((resolve: ()=> void) => {
            const cachedPolicy : string = localStorage.getItem(PRIVACY_POLICY);
            const cachedPhoneNumber : string = localStorage.getItem(PHONE_NUMBER);
            if (!cachedPolicy || !cachedPhoneNumber ) {
                privacyPolicyService.GetGenericContent().subscribe((result: GenericMemberResponsePortalResponseDto<GenericContentDto>) => {
                    if (result.Success){
                        localStorage.setItem(PRIVACY_POLICY, result.Data.PrivacyPolicy)
                        localStorage.setItem(PHONE_NUMBER, Helper.FormatPhoneNumber(result.Data.PhoneNumber))
                        resolve();
                    }
                });
            } else {
                resolve();
            }
        })
}
